import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 16,
	viewBox: "0 0 16 16",
	width: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m8 6.41421356 5.2928932 5.29289324c.3905243.3905243 1.0236893.3905243 1.4142136 0s.3905243-1.0236893 0-1.4142136l-6.00000002-5.99999998c-.39052429-.39052429-1.02368927-.39052429-1.41421356 0l-6 5.99999998c-.39052429.3905243-.39052429 1.0236893 0 1.4142136s1.02368927.3905243 1.41421356 0z" })
});
export default SvgChevronUp;
